<template>
  <div class="reset-password-confirm p-lg-5 p-md-4 p-3">
    <h1>Obnova hesla</h1>
    <hr>
    <div v-if="showSpinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>

    <form class="form-horizontal" autocomplete="off" v-if="showForm1" @submit.prevent="nothing()">
      <div class="form-group">
        <label class="col-sm-4 control-label">
          <nobr>Nové heslo</nobr>
          </label>
        <div class="col-sm-4">
          <input type="password" ref="newPassword" name="newPassword" class="form-control"
            v-model="inputNewPassword" :disabled="submitPending"
            v-validate="'required|min:6'"
            :class="{'is-danger': errors.has('newPassword') }"
            autofocus
          >
          <span v-if="errors.has('newPassword')" class="help is-danger">Vložte prosím nové heslo; minimální délka 6 znaků.</span>
          <span v-else>&nbsp;</span>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-4 control-label" />
        <div class="col-sm-4">
          <button v-on:click="submitPassword1" class="btn btn-primary"
            :disabled="submitPending || errors.has('newPassword') || inputNewPassword == ''">
            <span v-if="submitPending != 1">Pokračovat</span>
            <i v-if="submitPending == 1" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>

    <form class="form-horizontal" autocomplete="off" v-if="showForm2" @submit.prevent="nothing()">
      <div class="form-group">
        <label class="col-sm-4 control-label">
          <nobr>Zadejte nové heslo znovu pro kontrolu</nobr>
          </label>
        <div class="col-sm-4">
          <input type="password" ref="newPassword2" name="newPassword2" class="form-control"
            v-model="inputNewPassword2" :disabled="submitPending"
            :class="{'is-danger': inputNewPassword2 != '' && !passwordsMatch() }"
            autofocus
          >
          <span v-if="inputNewPassword2 != '' && !passwordsMatch()" class="help is-danger">Zadané heslo nesouhlasí. <a v-on:click="startOver">Zadat znovu?</a></span>
          <span v-else>&nbsp;</span>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-4 control-label" />
        <div class="col-sm-4">
          <button v-on:click="submitPassword2" class="btn btn-primary"
            :disabled="submitPending || !passwordsMatch() || inputNewPassword2 == ''">
            <span v-if="submitPending != 1">Nastavit nové heslo</span>
            <i v-if="submitPending == 1" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>

    <div class="form-group" v-if="showResult">
      Nové heslo je nastaveno. Můžete <router-link to="/login">pokračovat na přihlášení</router-link>.
    </div>

    <div class="form-group" v-if="displayError">
      <div class="col-sm-12 error-box">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ displayError }}
      </div>
      <div class="col-sm-12">
        <a href="/reset-password">Zapomněli jste heslo?</a>
      </div>
    </div>

  </div>
</template>

<script>
import SessionResource from '../backend-resources/session-resource'

export default {
  name: 'reset-password-confirmation-component',
  data: () => {
    return {
      showSpinner: false,
      showForm1: false,
      showForm2: false,
      showResult: false,
      displayError: null,
      inputNewPassword: '',
      inputNewPassword2: '',
      submitPending: false
    }
  },
  methods: {
    submitPassword1 () {
      this.showForm1 = false
      this.showForm2 = true
      setTimeout(() => {
        this.$refs.newPassword2.focus()
      }, 100)
    },
    submitPassword2 () {
      this.submitPasswordToBackend()
    },
    nothing () {
      return false
    },
    startOver () {
      this.showForm1 = true
      this.showForm2 = false
      this.inputNewPassword = ''
      this.inputNewPassword2 = ''
      setTimeout(() => {
        this.$refs.newPassword.focus()
      }, 100)
    },
    passwordsMatch () {
      return this.inputNewPassword === this.inputNewPassword2
    },
    submitPasswordToBackend () {
      let resetId = this.$route.params.id

      this.displayError = null
      this.submitPending = true
      let sr = new SessionResource()

      sr.resetPasswordSave(resetId, this.inputNewPassword2).then((response) => {
        this.submitPending = false
        this.showForm1 = false
        this.showForm2 = false
        this.showResult = true
      })
      .catch((error) => {
        this.submitPending = false
        if (error.response && error.response.status === 404) {
          this.displayError = 'Neplatný odkaz'
        } else if (error.response && error.response.status) {
          this.displayError = error.response.status + ' ' + error.response.statusText
        } else {
          this.displayError = error.toString()
        }
      })
    }
  },
  created: function () {
    let resetId = this.$route.params.id

    this.displayError = null
    this.showSpinner = true
    let sr = new SessionResource()
    sr.resetPasswordGet(resetId).then((response) => {
      this.showSpinner = false
      this.showForm1 = true
    })
    .catch((error) => {
      this.showSpinner = false
      if (error.response && error.response.status === 404) {
        this.displayError = 'Neplatný odkaz'
      } else if (error.response && error.response.status === 410) {
        this.displayError = 'Platnost odkazu pro změnu hesla již vypršela.'
      } else if (error.response && error.response.status) {
        this.displayError = error.response.status + ' ' + error.response.statusText
      } else {
        this.displayError = error.toString()
      }
    })
  }
}
</script>

<style scoped>
.reset-password-confirm {
  max-width: 1000px;
  margin: 0 auto;
  border-color: #e5e5e5 #eee #eee;
  border-style: solid;
  border-width: 1px 0;
  border-radius: 4px 4px 4px 4px;
  -webkit-box-shadow: inset 0 3px 6px rgba(0,0,0,.05);
          box-shadow: inset 0 3px 6px rgba(0,0,0,.05);
}
button {
  width: 100%;
}
.is-danger {
  border-color: #ff3860;
}
.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
  color: #ff3860;
}
h1 {
  text-transform: uppercase;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// ResetPasswordConfirm.vue?3eb35f70